import { useEffect } from 'react'
import { atom, useRecoilState } from 'recoil'
import { postRequest } from '/src/httpClient'

export const orderState = atom({
  key: 'orderState',
  default: false
})

export const useOrder = (uuid) => {
  const [results, setResults] = useRecoilState(orderState)

  useEffect(() => {
    const controller = new AbortController();

    (async () => {
      const response = await postRequest('/api/order/single', {
        uuid: uuid
      })

      // @todo, load the order items and store relationship data.
      if (response) {
        setResults(response)
      }
    })()

    return () => controller.abort()
  }, [uuid])

  return results
}
